import React, { useState, useEffect } from "react";
import { withRouter } from '../../common/withRouter';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Notification,
  ButtonOBSOLETED,
  Message
} from "../../web.common";
import withApi from "../higherOrderComponents/withApi";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";

const LockerCreateInternal = ({
  api,
  history
}) => {
  const initialData = {
    name: "",
    facility: {value: '', label: ''}
  };

  const [data, setData] = useState(initialData);
  const [lockerType, setLockerType] = useState(null);
  const [properties, setProperties] = useState([]);
  const [lockerTypeMapped, setLockerTypeMapped] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const [editedNotification, setNotification] = useState(null);
  const [alertedField, setAlertedField] = useState(null);

  const formLabelStyle = {
    display: "table-cell",
    width: "30%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top",
  };

  const formSpanStyle = {
    display: "table-cell"
  };

  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto",
    marginBottom: "0",
  };

  const containerStyle = {
    width: "80%",
    margin: "auto",
    backgroundColor: "white",
    border: "1px solid #e5e5e5",
    padding: "1.2rem",
  };

  useEffect(() => {
    async function loadFromApi() {
      const lockerTypesResponse = await api.lockers.getLockerTypes();

      setLockerTypeMapped(
        lockerTypesResponse.data.map((x) => ({ value: x.key, label: x.value }))
      );
    }

    if (!lockerTypeMapped) {
      loadFromApi();
    }
  });

  const selectionHandler = (selection) => {
    setLockerType(selection);

    if (selection.value == 0) {
      setIsSelected(false);
      return;
    }

    setData({...initialData, LockerType: selection.value});
    getPropertiesByType(selection.value);
    setIsSelected(true);
  };

  const showAlert = (field) => {
    return (<div style={rowStyle}>
      <label for={field+'-alert'} style={formLabelStyle}></label> 
      <span style={{ ...formSpanStyle, color: 'red', alignContent: 'center' }}>{field} is mandatory
      </span>
      </div>)
  };

  const getPropertiesByType = async (typeId) => {
    const propertiesResponse = await api.lockers.getPropertiesByTypeId(typeId);
    setProperties(propertiesResponse.data);
  };
  
  const lookupFacility = async (inputValue) => {
    const response = await api.facilities.lookupByNameOrId(inputValue);
    return response;
  };

  const propertiesMapped =
    properties.length > 0 &&
    properties.map((x) => (
      <>
        <div style={rowStyle} key={x}>
          <label for={x} style={formLabelStyle}>
            {x.toLowerCase() == 'randomcodelenght' ? 'Code Length' : x}
          </label>
          <span style={formSpanStyle}>
            <input
             style={alertedField == x ? {border: '1px solid red'} : {}}
              name={x}
              id={x}
              placeholder={x}
              required
              title={`${x} is mandatory`}
              onChange={({ target }) => {
                console.log(target.value)
                setAlertedField(null);
                setData({
                  ...data,
                  [x]: target.value
                })}
              }
              onBlur={({ target }) => {
                if (!target.value || target.value.trim() === '') {
                  setAlertedField(x)
                }
              }}
            />
          </span>
        </div>
        {alertedField == x ? showAlert(x) : null}
        <hr />
      </>
    ));

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={editedNotification} />
          <PageTop
            documentTitle={`Locker create`}
            documentDescription={`Locker create`}
          />
          {lockerTypeMapped ? (
            <React.Fragment>
              <br />
              <br />
              <br />
              <h3>New Locker</h3>
              {isSelected ? (
                <React.Fragment>
                  <div style={containerStyle}>
                    <div style={rowStyle}>
                      <label for="type" style={formLabelStyle}>
                        Type
                      </label>
                      <span style={formSpanStyle}>
                        <ReactSelect
                          className="react-select-filters-section"
                          classNamePrefix="react-select-filters-section-prefix"
                          value={lockerType || lockerTypeMapped[0]}
                          onChange={(selection) => {
                            selectionHandler(selection);
                          }}
                          options={lockerTypeMapped}
                        ></ReactSelect>
                      </span>
                    </div>
                    <hr />
                    <div style={rowStyle}>
                      <label for="name" style={formLabelStyle}>
                        Name
                      </label>
                      <span style={formSpanStyle}>
                        <input
                          name="name"
                          id="name"
                          value={data.name}
                          placeholder="name"
                          onChange={({ target }) =>
                            setData({
                              ...data,
                              name: console.log(target.value) || target.value,
                            })
                          }
                        />
                      </span>
                    </div>
                    <hr />
                    <div style={rowStyle}>
                      <label for="facility" style={formLabelStyle}>
                        Facility
                      </label>
                      <span style={formSpanStyle}>
                      <AsyncSelect
                          className="react-select-filters-section"
                          classNamePrefix="react-select-filters-section-prefix"
                          defaultOptions
                          value = {data.facility || '' }
                          cacheOptions
                          onChange={(selection) =>
                            setData({
                              ...data,
                              facility: console.log(selection) || selection,
                            })
                          }
                          loadOptions={async (inputValue) => lookupFacility(inputValue)}
                        ></AsyncSelect>
                      </span>
                    </div>
                    <hr />
                    {propertiesMapped}
                    <br />
                        <br />
                        <div style={{ justifyContent: 'center', display: 'flex', gap: '1.5rem' }}>
                          <ButtonOBSOLETED
                            type="submit"
                            buttonContent="Save"
                            onClick={async () => 
                            {
                               const response = await api.lockers.addLocker(data);
                              if (response.hasOwnProperty('success') && response.success === false) {
                                setNotification(new Message('error', `Unable to add the locker. ${response.message}`));
                                return;
                               }
                               history.push('/locker/' + response.id);
                            }}
                            />
                             <ButtonOBSOLETED
                            type="reset"
                            buttonContent="Cancel"
                            onClick={async () => {
                              selectionHandler({value: 0, label:"UNDEFINED"});
                            }} />
                        </div>
                  </div>
                </React.Fragment>
              ) : (
                <div style={containerStyle}>
                  <div style={rowStyle}>
                    <label for="type" style={formLabelStyle}>
                      Type
                    </label>
                    <span style={formSpanStyle}>
                      <ReactSelect
                        className="react-select-filters-section"
                        classNamePrefix="react-select-filters-section-prefix"
                        value={lockerType || lockerTypeMapped[0]}
                        onChange={(selection) => {
                          selectionHandler(selection);
                        }}
                        options={lockerTypeMapped}
                      ></ReactSelect>
                    </span>
                  </div>
                </div>
              )}
            </React.Fragment>
          ) : (
            "..loading..."
          )}
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

const LockerCreate = withRouter(
  withApi(
    connect(
      ({ user, categories }) => ({ isLoggedIn: !!user, categories }),
      {}
    )(LockerCreateInternal)
  )
);

LockerCreate.requiresLogin = true;
LockerCreate.propTypes = { isLoggedIn: PropTypes.bool };

export default LockerCreate;
